module.exports = __webpack_public_path__ + "hyperion-v2-static/img/reset_filters.2e0924e5.png";